export default __webpack_public_path__ + "static/media/primaafp3.686c8079.jpg";